import { render, staticRenderFns } from "./SpeisenProdukte.vue?vue&type=template&id=54703daf&scoped=true"
import script from "./SpeisenProdukte.vue?vue&type=script&lang=js"
export * from "./SpeisenProdukte.vue?vue&type=script&lang=js"
import style0 from "./SpeisenProdukte.vue?vue&type=style&index=0&id=54703daf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54703daf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54703daf')) {
      api.createRecord('54703daf', component.options)
    } else {
      api.reload('54703daf', component.options)
    }
    module.hot.accept("./SpeisenProdukte.vue?vue&type=template&id=54703daf&scoped=true", function () {
      api.rerender('54703daf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SpeisenProdukte.vue"
export default component.exports